import {
  fork,
  all,
  call,
  takeLatest,
  takeEvery,
  select,
  put,
} from "redux-saga/effects";
import api from "helpers/api";

import search from "../modules/search";
import editing from "../modules/editing";
import persons from "../modules/persons";
import person from "../modules/person";
import addresses from "../modules/addresses";

const getCurrentSearch = (state) => state.search;
const getCurrentPersons = (state) => state.persons;

function* watchFetchSearch() {
  yield takeLatest(search.types.FETCH_SEARCH, fetchSearch);
}

function* fetchSearch({ query, page }) {
  const { data } = yield call(api.fetchSearch, query, page);
  if (!page) {
    yield put(search.actions.fetchSearchSuccess(data.response));
  } else {
    yield put(search.actions.fetchNextPageSuccess(data.response));
  }

  if (data.response.total_pages === 1) {
    yield put(search.actions.fetchSearchFinish());
  }
}

function* fetchNextPage() {
  let { currentPage, query, totalPages } = yield select(getCurrentSearch);
  currentPage++;

  if (currentPage === totalPages) {
    yield put(search.actions.fetchSearchFinish());
  }

  yield call(fetchSearch, { query, page: currentPage });
}

function* watchFetchNextPage() {
  yield takeEvery(search.types.FETCH_NEXT_PAGE, fetchNextPage);
}

function* watchFetchEdits() {
  yield takeEvery(editing.types.FETCH_EDITS, fetchEdits);
}

function* fetchEdits({ data, id, entity }) {
  const { result } = yield call(api.fetchEdits, { data, id, entity });
  console.log("❗", result);
}

function* watchFetchPersons() {
  yield takeEvery(persons.types.FETCH_PERSONS, fetchPersons);
}

function* fetchPersons() {
  let { currentPage, letter } = yield select(getCurrentPersons);
  currentPage++;

  letter = letter === "Все:" ? "" : letter;
  const { data } = yield call(api.fetchPersons, { page: currentPage, letter });

  if (
    data.response.total_pages === 1 ||
    data.response.total_pages === data.response.current_page
  ) {
    yield put(persons.actions.fetchPersonsFinish());
  }

  yield put(persons.actions.fetchPersonsSuccess(data.response));
}

function* watchFetchFilterPersons() {
  yield takeEvery(persons.types.FETCH_FILTER_PERSONS, fetchFilterPersons);
}

function* fetchFilterPersons({ letter }) {
  let { currentPage } = yield select(getCurrentPersons);
  currentPage++;

  letter = letter === "Все:" ? "" : letter;
  const { data } = yield call(api.fetchPersons, { page: currentPage, letter });

  if (
    data.response.total_pages === 1 ||
    data.response.total_pages === data.response.current_page
  ) {
    yield put(persons.actions.fetchPersonsFinish());
  }

  yield put(persons.actions.fetchPersonsSuccess(data.response));
}

function* fetchPerson({ id }) {
  const { data } = yield call(api.fetchPerson, id);
  yield put(person.actions.fetchPersonSuccess(data.response.data));
}

function* watchFetchPerson() {
  yield takeEvery(person.types.FETCH_PERSON, fetchPerson);
}

function* fetchAddresses() {
  const { data } = yield call(api.fetchAddresses);

  yield put(addresses.actions.fetchAddressesSuccess(data.response.data));
}

function* watchFetchAddresses() {
  yield takeEvery(addresses.types.ADDRESSES_FETCH, fetchAddresses);
}

export default function* rootSaga() {
  try {
    yield all([
      fork(watchFetchSearch),
      fork(watchFetchNextPage),
      fork(watchFetchEdits),
      fork(watchFetchPersons),
      fork(watchFetchPerson),
      fork(watchFetchFilterPersons),
      fork(watchFetchAddresses),
    ]);
  } catch (err) {
    console.log(err);
  }
}



// WEBPACK FOOTER //
// ./src/sagas/index.js